export function overlayDecryptedValue({
  value,
  getHighlySensitivePropertyValue,
  objectId,
  objectTypeId,
  propertyName,
  timestamp
}) {
  if (!objectId) {
    return value;
  }
  const highlySensitivePropertyValue = getHighlySensitivePropertyValue({
    objectTypeId,
    objectId,
    propertyName,
    timestamp
  });

  // Purposely exclude empty string from this check because we are aiming
  // to query for values that are encrypted which are returned as undefined/null from
  // REST and GQL apis
  const isMissingValue = value === undefined || value === null;
  const hasDecryptedValue = (highlySensitivePropertyValue === null || highlySensitivePropertyValue === void 0 ? void 0 : highlySensitivePropertyValue.status) === 'SUCCEEDED';
  const overlayedValue = isMissingValue && hasDecryptedValue ? highlySensitivePropertyValue.value : value;
  return overlayedValue;
}